import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { PipesModule } from '../pipes/pipes.module';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { NavComponent } from './nav/nav.component';
import { TodoInputFieldComponent } from './todo-input-field/todo-input-field.component';
import { TodoListComponent } from './todo-list/todo-list.component';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    PipesModule,
  ],
  declarations: [
    HeaderComponent,
    NavComponent,
    TodoInputFieldComponent,
    TodoListComponent,
    FooterComponent,
  ],
  exports: [
    HeaderComponent,
    NavComponent,
    TodoInputFieldComponent,
    TodoListComponent,
    FooterComponent,
  ],
})
export class ComponentsModule {}
